import React, { useState } from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const RichSliderContainer = styled(Box)(({ theme, color }) => ({
  width: '100%',
  padding: theme.spacing(1),
  // Apply color to the container (will be inherited by children)
  color: color || theme.palette.text.primary,
}));

const LabelContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
}));

// Customize the Slider with color prop
const CustomSlider = styled(Slider)(({ theme, color }) => ({
  // Apply the color to various parts of the Slider
  '& .MuiSlider-rail': {
    color: color,
  },
  '& .MuiSlider-track': {
    color: color,
  },
  '& .MuiSlider-thumb': {
    color: color,
  },
  '& .MuiSlider-valueLabel': {
    color: color,
  }
}));

function RichSlider({ icon, text, subText, min, max, color, defaultValue, step, onChange, width=200, ...props }) {
  const [value, setValue] = useState(defaultValue || min);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onChange?.(newValue);
  };

  return (
    <RichSliderContainer color={color} style={{width}}>
      <LabelContainer>
        <span className={'text-sm font-medium'} style={{color}}>
          {text}
        </span>
        <Typography type="secondary">
          {subText}
        </Typography>
      </LabelContainer>
      {/* Use the customized Slider */}
      <CustomSlider
        color={color} // Pass the color prop
        value={value}
        min={min}
        max={max}
        onChange={handleChange}
        aria-labelledby="rich-slider"
        valueLabelDisplay="auto"
        step={step}
        {...props}
      />
    </RichSliderContainer>
  );
}

export default RichSlider;